export default {
  sitewide: {
    enabled: true,
    message:
      "<b>27/03/2023:</b> We're working on updating the feedback system. Expect some issues with feedback messages throughout this week.",
  },
};
